
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/swa/weekly-promos",
      function () {
        return require("private-next-pages/swa/weekly-promos/index.js");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/swa/weekly-promos"])
      });
    }
  